import { Routes } from '@angular/router';

import { navigationGuard, permissionGuard } from '@core/guards';

export const settingsRoutes: Routes = [
  {
    path: 'settings',
    loadComponent: () =>
      import('@features/settings/settings.component').then(
        c => c.SettingsComponent
      ),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'notifications',
      },
      {
        path: 'notifications',
        loadComponent: () =>
          import(
            '@features/settings/notifications/notifications.component'
          ).then(m => m.NotificationsComponent),
        canActivate: [
          permissionGuard([
            'clientEmailNotificationsView',
            'clientSystemNotificationsView',
          ]),
        ],
        canDeactivate: [navigationGuard],
      },
    ],
  },
];
